import(/* webpackMode: "eager" */ "/codebuild/output/src293353159/src/app/(dashboard)/page.js");
